<ng-container *ngIf="showIcon">
  <div class="listbox-empty-icon">
    <ng-content select="[icon]" />
  </div>
</ng-container>

<div class="listbox-empty-text">
  <ng-content select="[text]" />
</div>
